import React from 'react';
import { RefreshCw, Trash2, Edit3 } from 'lucide-react';

interface BatchActionBarProps {
  selectedCount: number;
  batchDeleting: boolean;
  activeTab: string;
  onBatchDelete: () => void;
  onBatchClearMessages: () => void;
  onCancel: () => void;
}

export const BatchActionBar: React.FC<BatchActionBarProps> = ({
  selectedCount,
  batchDeleting,
  activeTab,
  onBatchDelete,
  onBatchClearMessages,
  onCancel,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-white border border-wedding-pink/20 rounded-lg shadow-lg px-6 py-4 flex items-center space-x-4 z-50">
      <span className="text-sm text-wedding-text-body">
        已選擇 <span className="font-semibold text-wedding-pink">{selectedCount}</span> 項
      </span>
      <div className="h-4 w-px bg-wedding-pink/20"></div>

      {activeTab === 'messages' ? (
        <>
          <button
            onClick={onBatchClearMessages}
            disabled={batchDeleting}
            className="px-4 py-2 bg-wedding-pink text-white rounded-md hover:bg-wedding-pink/90 disabled:opacity-50 flex items-center space-x-2"
          >
            {batchDeleting ? (
              <RefreshCw className="h-4 w-4 animate-spin" />
            ) : (
              <Edit3 className="h-4 w-4" />
            )}
            <span>{batchDeleting ? '處理中...' : '清空留言'}</span>
          </button>
          <button
            onClick={onBatchDelete}
            disabled={batchDeleting}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 flex items-center space-x-2"
          >
            {batchDeleting ? (
              <RefreshCw className="h-4 w-4 animate-spin" />
            ) : (
              <Trash2 className="h-4 w-4" />
            )}
            <span>{batchDeleting ? '刪除中...' : '刪除記錄'}</span>
          </button>
        </>
      ) : (
        <button
          onClick={onBatchDelete}
          disabled={batchDeleting}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 flex items-center space-x-2"
        >
          {batchDeleting ? (
            <RefreshCw className="h-4 w-4 animate-spin" />
          ) : (
            <Trash2 className="h-4 w-4" />
          )}
          <span>{batchDeleting ? '刪除中...' : '批次刪除'}</span>
        </button>
      )}

      <button
        onClick={onCancel}
        className="px-4 py-2 border border-wedding-pink/30 text-wedding-text-body rounded-md hover:bg-wedding-pink/5"
      >
        取消
      </button>
    </div>
  );
};
